import { render, staticRenderFns } from "./VCompanySearchField.vue?vue&type=template&id=2fa5cb98&"
import script from "./VCompanySearchField.vue?vue&type=script&lang=js&"
export * from "./VCompanySearchField.vue?vue&type=script&lang=js&"
import style0 from "./VCompanySearchField.vue?vue&type=style&index=0&id=2fa5cb98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports